module.exports = __webpack_public_path__ + "img/9788972573807.ed6bc016.jpg";